import Tippy, { TippyProps } from '@tippyjs/react';

import React from 'react';

type TippySize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export interface UDTippyProps extends Omit<TippyProps, 'size'> {
  size?: TippySize;
}

/**
 * UDTippy - компонент тултипа с возможностью настройки размера шрифта
 * По умолчанию имеет placement="right" и theme="light"
 */
const UDTippy: React.FC<UDTippyProps> = ({
  children,
  size = 'md',
  placement = 'right',
  theme = 'light',
  trigger = 'mouseenter focus',
  ...props
}) => {
  // Функция для установки класса размера
  const setSizeClass = (instance: any) => {
    const tippyBox = instance.popper?.querySelector('.tippy-box');
    if (tippyBox) {
      // Удаляем все классы размеров
      tippyBox.classList.remove(
        'tippy-size-xxs',
        'tippy-size-xs',
        'tippy-size-sm',
        'tippy-size-md',
        'tippy-size-lg',
        'tippy-size-xl',
        'tippy-size-xxl',
      );

      // Добавляем нужный класс размера
      tippyBox.classList.add(`tippy-size-${size}`);
    }
  };

  if (!props.content) {
    return children || null;
  }

  return (
    <Tippy
      placement={placement}
      theme={theme}
      trigger={trigger}
      {...props}
      onCreate={(instance) => {
        setSizeClass(instance);

        // Вызываем оригинальный onCreate, если он был передан
        if (props.onCreate) {
          props.onCreate(instance);
        }
      }}
      onMount={(instance) => {
        setSizeClass(instance);

        // Вызываем оригинальный onMount, если он был передан
        if (props.onMount) {
          props.onMount(instance);
        }
      }}
      onShow={(instance) => {
        setSizeClass(instance);

        // Вызываем оригинальный onShow, если он был передан
        if (props.onShow) {
          props.onShow(instance);
        }
      }}
    >
      {children}
    </Tippy>
  );
};

export default UDTippy;
